var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.chipsFilter
        ? _c(_setup.GridChipsFiltersComponent, {
            attrs: { filters: _setup.filters },
            on: { removeFilter: _setup.onRemoveFilter },
          })
        : _vm._e(),
      _setup.columns
        ? _c(
            _setup.EjsGrid,
            {
              ref: "grid",
              class: ["grid-table", { "grid-disabled": _vm.disabled }],
              attrs: {
                width: "100%",
                allowPaging: _vm.allowPaging,
                allowSorting: _vm.allowSorting,
                allowFiltering: _vm.allowFiltering,
                allowExcelExport: true,
                allowReordering: true,
                allowPdfExport: true,
                allowResizing: true,
                contextMenuItems: _vm.contextMenuItems,
                contextMenuModule: true,
                dataSource: _vm.itemData,
                enablePersistance: true,
                selectionSettings: _vm.selectionOptions,
                showColumnChooser: _vm.showColumnChooser,
                rowHeight: 40,
                childGrid: _vm.childGrid,
                toolbar: _setup.toolbarOptionsParsed,
                pageSettings: _setup.pageSettings,
                filterSettings: _setup.filterSettings,
                searchSettings: _setup.searchSettings,
                sortSettings: _setup.sortSettings,
                sortModule: true,
                columnChooserSettings: _vm.columnChooserSettings,
              },
              on: {
                contextMenuClick: _setup.onContextMenuClicked,
                contextMenuOpen: _setup.onContextMenuBeforeOpen,
                commandClick: _setup.onCommandClicked,
                rowSelected: _setup.onRowSelected,
                rowDeselected: _setup.onRowSelected,
                recordClick: _setup.onRowClick,
                rowDataBound: _vm.rowDataBound,
                dataBound: _setup.onDataBound,
                pdfExportComplete: _setup.onPdfExportComplete,
                pdfQueryCellInfo: _setup.onPdfQueryCellInfo,
                toolbarClick: _setup.onToolbarClicked,
                actionBegin: _setup.onActionBegin,
                dataStateChange: _setup.onDataStateChange,
                created: _setup.onGridCreated,
              },
            },
            [
              _c(
                _setup.EColumns,
                _vm._l(_setup.columns, function (column, index) {
                  return _c(_setup.EColumn, {
                    key: `column-${index}`,
                    attrs: {
                      filter: _setup.getCustomFilter(column),
                      clipMode: _setup.getClipMode(column),
                      allowFiltering: column.allowFiltering,
                      allowReordering: column.allowReordering,
                      allowResizing: column.allowFiltering,
                      allowSorting: column.allowSorting,
                      commands: column.commands,
                      field: column.field,
                      filterModule: column.filterModule,
                      format: column.format,
                      headerTemplate: column.headerTemplate,
                      headerText: column.headerText,
                      headerTextAlign: column.headerTextAlign,
                      isPrimaryKey: column.isPrimaryKey ? true : false,
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                      textAlign: column.textAlign,
                      type: column.type,
                      visible: column.visible,
                      width: column.width,
                      showInColumnChooser: column.showInColumnChooser,
                      template: _setup.getTemplate(column),
                      freeze: _vm.childGrid ? undefined : column.freeze,
                      tags: column.tags,
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("ejs-contextmenu", {
        ref: "customToolbarContextMenu",
        attrs: {
          id: "customToolbarContextMenu",
          items: _setup.customToolbarContextMenuItems,
        },
        on: { select: _setup.customToolbarContextMenuClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }